import React from "react";
import { FacilityOrderTemplateItemEditTemplate } from "themes/application/facility-order/components";
import { observer } from "mobx-react";

@observer
class FacilityOrderTemplateItemEdit extends React.Component {
	render() {
		return <FacilityOrderTemplateItemEditTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateItemEdit;